<template>
<div class="catalog">

	<!-- page header -->
    <page-heading show="true" pageTitle="HEADER-CATALOG-HISTORY"></page-heading>

    <!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<div class="columns" v-if="!isLoading">

		<div class="col-main">

            <!--
            <form class="control has-addons is-pulled-left" @submit.prevent="submitSearch">
                <input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
                <a class="button is-info" @click="submitSearch"><span class="icon is-small"><i class="fa fa-search"></i></span></a>
            </form>
            -->

            <!--search -->
            <div class="control has-icon search is-pulled-left">
                <input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
                <i class="fa fa-search" aria-hidden="true"></i>
            </div>

            <!-- Filter -->
            <template v-if="['productsHistory', 'catalogHistory', 'apoHistory'].indexOf($route.name) > -1">
            <span class="select is-pulled-right" v-if="userRole != 'Industriepartner' && $route.name != 'equipmentCatalogPageChangeLog' && $route.name != 'equipmentCatalogChangeLog'">

                <select v-model="selectedFilterType" v-on:change="filterType">

                    <option value="null">{{ $t("SELECT_BOX-HISTORY-FILTER-NONE") }}</option>

                    <!-- Filter for products only -->
                    <template v-if="$route.name == 'productsHistory'">
                        <option value="Product">{{ $t("SELECT_BOX-HISTORY-FILTER-PRODUCT") }}</option>
                        <option value="ProductVoucher">{{ $t("SELECT_BOX-HISTORY-FILTER-PRODUCT_VOUCHER") }}</option>
                        <option value="ProductVariant">{{ $t("SELECT_BOX-HISTORY-FILTER-PRODUCT_VARIANT") }}</option>
                    </template>

                    <!-- Filter for catalog only -->
                    <template v-else-if="$route.name == 'catalogHistory'">
                        <option value="CatalogPage">{{ $t("SELECT_BOX-HISTORY-FILTER-CATALOG_PAGE") }}</option>
                        <option value="CatalogPageElement">{{ $t("SELECT_BOX-HISTORY-FILTER-CATALOG_PAGE_ELEMENT") }}</option>
                    </template>

                    <!-- filter for pharmacies only -->
                    <template v-else-if="$route.name == 'apoHistory'">
                        <option value="SiteCatalogCustomization">{{ $t("SELECT_BOX-HISTORY-FILTER-SITE_CATALOG_CUSTOMIZATION") }}</option>
                        <option value="TERM_SITE_CATALOG_STATUS_PRINT_APPROVED">{{ $t('TERM_SITE_CATALOG_STATUS_PRINT_APPROVED') }}</option>
                    </template>

                </select>

            </span>
            </template>


            <v-client-table class="tblHistory" :name="'tbl-history'+tblClass" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions">

                <template slot="loggedAt" slot-scope="props">
                    <span v-html="formatDate(props.row.loggedAt, true)" style="font-size: 11px; color: #444;"></span>
                </template>

                <template slot="event" slot-scope="props">
                    <template v-if="props.row.objectExtRef != ''">{{ props.row.objectExtRef }} - </template>
                    <lang :labelKey="getEventDescription(props.row)" :uppercase="false" :labelKey2="props.row.label"></lang>
                </template>

            </v-client-table>

		</div>

	</div>

</div>
</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

	name: 'logs',

	data() {

        var self = this;

		return {
            isLoading: false,
            objectClass: '',
            tblClass: '',
            searchString: '',
            selectedCategory: null,
            selectedFilterType: null,
            table: {
                tblData: [],
                tblColumns: ['loggedAt', 'username', 'event'],
                tblOptions: {
                    trackBy: 'loggedAt',
                    perPage: 25,
                    orderBy: {
						ascending: false,
						column: 'loggedAt'
					},
                    sortable: ['loggedAt', 'username'],
                    filterByColumn: false,
					filterable: false,

                    // custom table headings - make them clickable for language Setting
                    headings: {

                        loggedAt: function(h) {
                            return <lang labelKey="HISTORY-TBL_HEADER-DATE"></lang>
                        },

                        username: function(h) {
                            return <lang labelKey="HISTORY-TBL_HEADER-USER"></lang>
                        },

                        event: function(h) {
                            return <lang labelKey="HISTORY-TBL_HEADER-EVENT"></lang>
                        },

                    },

                    sortIcon: {
                        base:'fa fa-sort',
                        up:'fa-sort-up',
                        down:'fa-sort-down'
                    },

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
					customFilters: [
                        {
							name: 'search',
							callback: function(row, string) {

								if(string != "") {

									return row.objectName != null
                                        && row.username.toLowerCase().indexOf(string) >= 0
                                        || row.objectName.toLowerCase().indexOf(string) >= 0
                                        || row.value != '' && row.value.toLowerCase().indexOf(string) >= 0
                                        || row.objectExtRef != '' && row.objectExtRef.indexOf(string) >= 0
                                        || row.valueLabel != '' && self.$t(row.valueLabel).toLowerCase().indexOf(string) >= 0;
								}

                                return true;

							}
						},

                        {
							name: 'filterType',
							callback: function(row, type) {

                                if(type == "null")
                                    return true;

                                return row.objectClass == type || row.valueLabel == type;

							}
						}


					],


                }
            }

		}
	},

    watch: {

        searchString(val) {

            // let type = this.selectedCategory != null ? this.selectedCategory : null;
            // this.selectedCategory = '';
			Event.$emit('vue-tables.tbl-history'+this.tblClass+'.filter::search', val.toLowerCase() );


        }

    },


	created() {

        switch(this.$route.name) {

            case 'catalogChangeLog':
            case 'catalogHistory':
                this.tblClass = '-catalog';
                this.objectClass = "Apokat%5CEntity%5CCatalogPage,Apokat%5CEntity%5CCatalogPageElement";
                break;

            case 'catalogPageChangeLog':
            case 'catalogPageHistory':
                this.tblClass = '-catalog';
                this.objectClass = "Apokat%5CEntity%5CCatalogPage,Apokat%5CEntity%5CCatalogPageElement&catalogPage="+this.$route.params.page1ID;
                break;

            case 'apoHistory':
                this.tblClass = '-apos';
                this.objectClass = "Apokat%5CEntity%5CSiteCatalog,Apokat%5CEntity%5CSiteCatalogCustomization";
                break;

            case 'productsHistory':
                this.tblClass = '-products';
                this.objectClass = "Core%5CEntity%5CProduct,Core%5CEntity%5CProductVariant,Core%5CEntity%5CProductAsset,Core%5CEntity%5CProductVoucher";
                break;

            case 'equipmentCatalogChangeLog':
                this.tblClass = '-ecChangelog';
                this.objectClass = "Apokat%5CEntity%5CEquipment,Apokat%5CEntity%5CEquipmentCatalog,Apokat%5CEntity%5CEquipmentCatalogPage,Apokat%5CEntity%5CEquipmentCatalogSection,Apokat%5CEntity%5CEquipmentCategory,Apokat%5CEntity%5CEquipmentCatalogPageElement,Apokat%5CEntity%5CEquipmentOnlineCategory,Apokat%5CEntity%5CEquipmentLink";
                break;

            case 'equipmentCatalogPageChangeLog':
                this.tblClass = '-ecpChangelog';
                this.objectClass = "Apokat%5CEntity%5CEquipmentCatalogPage,Apokat%5CEntity%5CEquipmentCatalogPageElement&equipmentCatalogPage="+this.$route.params.equipmentCatalogPageID;
                break;


            case 'complatContentPoolContentChangeLog':
                this.tblClass = '-cpcChangelog';
                this.objectClass = "Apokat%5CEntity%5CArticle,Apokat%5CEntity%5CArticleVariant&article="+this.$route.params.contentID;
                break;

            case 'complatContentPoolContentVariantChangeLog':
                this.tblClass = '-cpcvChangelog';
                this.objectClass = "Apokat%5CEntity%5CArticleVariant&articleVariant="+this.$route.params.contentVariantID;
                break;

            case 'complatImagePool':
                this.tblClass = '-ipChangelog';
                this.objectClass = "Apokat%5CEntity%5CAsset";
                break;

            case 'complatImagePoolImage':
                this.tblClass = '-ipiChangelog';
                this.objectClass = "Apokat%5CEntity%5CArticleVariant&articleVariant="+this.$route.params.imageID;
                break;
        }

        this.fetchData();

	},

	mounted() {

    	Event.$on('vue-tables.tbl-history'+this.tblClass+'.row-click', function (data) {

            var link = "";

            switch(data.row.linkObjectClass) {

                case 'CatalogPage':
                    var ids = "";
                    if(data.row.linkObjectId % 2 == 0) {
                        ids = data.row.linkObjectId+'-'+(parseInt(data.row.linkObjectId)+1);
                    } else {
                        ids = (parseInt(data.row.linkObjectId)-1)+'-'+ data.row.linkObjectId;
                    }
                    link = "seite-" + ids;
                    break;

                case 'CatalogPageElement':
                    link = "pageElement-" + data.row.linkObjectId;
                    break;

                case 'ProductVoucher':
                case 'Product':
                    link = "produkt-" + data.row.linkObjectId;
                    break;

                case 'Site':
                    link = "apotheke-" + data.row.linkObjectId;
                    break;

                default:
                    link = "";

            }

            // return;
            if(link != "") {
                this.$router.push(link);
            }

    	}.bind(this));

	},

	updated() {

	},

	computed: {

        url() {
            return this.$config.api + 'logEntry/friendlyList?maxResults=1000&orderBy=loggedAt%20DESC&filters[objectClass]='+this.objectClass;
        }

    },

	methods: {

        submitSearch() {

            var type = this.selectedCategory != null ? this.selectedCategory : null;
			var string = this.searchString;
            this.selectedCategory = '';
			Event.$emit('vue-tables.tbl-history'+this.tblClass+'.filter::search', {type, string} );

		},


        filterType() {

            var type = this.selectedFilterType;
			Event.$emit('vue-tables.tbl-history'+this.tblClass+'.filter::filterType', type );

		},

        fetchData() {

            this.isLoading = true;

            var self = this;

            this.axios.get(this.url)
    			.then(function(response) {
    				self.table.tblData = response.data.logEntry;
                    self.isLoading = false;
    			}).catch(function(error) {
    				console.log('Error: ', error.message);
    				self.isLoading = false;
    			});

        },

        getEventDescription(row) {

            var valueLabel = "";

            if(row.action == 'upload') {
                // valueLabel = '<a href="'+this.$config.assets + JSON.parse(row.value)+'" target="_blank">'+JSON.parse(row.value)+'</a>';
                valueLabel = '<small>[<a href="'+this.$config.assets + JSON.parse(row.value)+'" target="_blank">Datei ansehen</a>]</small>';

            } else {
                valueLabel = row.valueLabel != 'null' && row.valueLabel != null ? this.$t(row.valueLabel) : JSON.parse(row.value);
            }

            return this.$t(row.label, {
                OBJECT_NAME: '<strong>'+row.objectName+'</strong>',
                VALUE: '<strong>'+valueLabel+'</strong>'
            });

        },

	}

}
</script>


<style scoped>
    .tblHistory >>> tr td {
        cursor: pointer;
    }
    .tblHistory >>> th:first-child {
        width: 150px;
    }
    .tblHistory >>> th:nth-child(2) {

    }
    .tblHistory >>> td:nth-child(2) {
        white-space: normal;
        text-overflow: clip;
        width: 300px;
    }

    .tblHistory >>> td:nth-child(3) span {
        white-space: pre-line;
    }
</style>
